module.exports = __webpack_public_path__ + "img/qr@2x.79bd98a2.png";